import React from "react";
import "./style.scss";
import Icon5 from "../../../../icons/Icon5/Icon5";
import logo from "../../../../../../assets/static/img/Logo-Horizontal-Dark.png";

const ROWS = [
  {
    feature: "Easy Match Discovery",
    cf: "Instantly find cards and collectors that match your interests",
    fb: "No smart filtering or search tools",
    ss: "No way to match or connect with others",
  },
  {
    feature: "Organized Collection",
    cf: "Visual, structured, and always up-to-date",
    fb: "Chaotic, post-based format",
    ss: "Manual and hard to maintain",
  },
  {
    feature: "Direct Trading",
    cf: "Trade cards directly in just a few clicks",
    fb: "Messaging-based, slow and unstructured",
    ss: "No built-in trading features",
  },
  {
    feature: "Shareable Collection",
    cf: "Share your portfolio with a simple, clean link",
    fb: "Can’t easily share your collection",
    ss: "Only possible with clunky exported files",
  },
  {
    feature: "Professional Look & Feel",
    cf: "Built to showcase your cards beautifully",
    fb: "Lacks design or layout for collections",
    ss: "Basic and not visually appealing",
  },
  {
    feature: "Fast Updates",
    cf: "Add, remove, or update cards in real time",
    fb: "Manual posts for every change",
    ss: "Requires editing files manually",
  },
  {
    feature: "Mobile-Friendly",
    cf: "Designed for seamless use on phones and tablets",
    fb: "Limited usability; not optimized for mobile",
    ss: "Difficult to use on mobile devices",
  },
];

const TabletExperienceSubsection = ({ t }) => {
  return (
    <section className="tablet-experience" aria-labelledby="tx-title">
      <div className="container">
        <header className="tx-head">
          <h2 id="tx-title" className="tx-kicker">
            {t("Stop Managing Your Collection Like It's 2005")}
          </h2>
          <p className="tx-subtitle">
            {t(
              "Designed to simplify your hobby — so you can focus on what truly matters: your collection."
            )}
          </p>
        </header>

        {/* Desktop / tablet table */}
        <div className="tx-table" role="table" aria-label={t("CardsFolio comparison")}>
          <div className="tx-row tx-row--head" role="row">
            <div className="tx-cell tx-cell--feat" role="columnheader">
              {t("Feature")}
            </div>
            <div className="tx-cell" role="columnheader">
              <span className="tx-badge">
                
                <img src={logo} alt="CardsFolio" className="tx-logo" style={{width:'50%',height:'50%'}} />
              </span>
            </div>
            <div className="tx-cell" role="columnheader">
              {t("Facebook Groups")}
            </div>
            <div className="tx-cell" role="columnheader">
              {t("Spreadsheets")}
            </div>
          </div>

          {ROWS.map((row, i) => (
            <div className="tx-row" role="row" key={i}>
              <div className="tx-cell tx-cell--feat" role="cell">
                {t(row.feature)}
              </div>

              <div className="tx-cell tx-cell--check" role="cell">
                
                <p><span className="tx-check" aria-hidden="true" />{t(row.cf)}</p>
              </div>

              <div className="tx-cell" role="cell">
                <p>{t(row.fb)}</p>
              </div>

              <div className="tx-cell" role="cell">
                <p>{t(row.ss)}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile stacked comparison */}
        <div className="tx-mobile" aria-label={t("CardsFolio comparison")}>
          {ROWS.map((row, i) => (
            <article className="tx-mobile-card" key={`mobile-${i}`}>
              <h3 className="tx-mobile-title">{t(row.feature)}</h3>

              <div className="tx-mobile-block tx-mobile-block--good">
                <div className="tx-mobile-label">
                  <span className="tx-check" aria-hidden="true" />
                  <span>{t("CardsFolio")}</span>
                </div>
                <p>{t(row.cf)}</p>
              </div>

              <div className="tx-mobile-block">
                <div className="tx-mobile-label">{t("Facebook Groups")}</div>
                <p>{t(row.fb)}</p>
              </div>

              <div className="tx-mobile-block">
                <div className="tx-mobile-label">{t("Spreadsheets")}</div>
                <p>{t(row.ss)}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TabletExperienceSubsection;